var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.87869 4.21201C2.60011 4.49058 2.37913 4.8213 2.22836 5.18528C2.0776 5.54926 2 5.93937 2 6.33334C2 6.72731 2.0776 7.11742 2.22836 7.4814C2.37913 7.84538 2.60011 8.1761 2.87869 8.45467L8.00003 13.576L13.1214 8.45467C13.684 7.89206 14 7.12899 14 6.33334C14 5.53768 13.684 4.77462 13.1214 4.21201C12.5587 3.64939 11.7957 3.33332 11 3.33332C10.2044 3.33332 9.4413 3.64939 8.87869 4.21201L8.00003 5.09067L7.12136 4.21201C6.84278 3.93343 6.51206 3.71244 6.14808 3.56168C5.78411 3.41091 5.39399 3.33331 5.00003 3.33331C4.60606 3.33331 4.21595 3.41091 3.85197 3.56168C3.48799 3.71244 3.15727 3.93343 2.87869 4.21201Z",
    stroke: "#09090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartOutline);
export default __webpack_public_path__ + "static/media/HeartOutline.4b2bb46f02517b313b50900fbe67bb44.svg";
export { ForwardRef as ReactComponent };